var _style, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarProfileLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 150",
    style: {
      enableBackground: "new 0 0 150 150",
      fill: "#010b6c"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M133.8,139.8H16.2c-3.3,0-6-2.7-6-6V16.2c0-3.3,2.7-6,6-6h117.5c3.3,0,6,2.7,6,6v117.5 C139.8,137.1,137.1,139.8,133.8,139.8z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M124.8,70.4c0,0-0.8-3.7-2.9-6.3l-0.1-21.7c0,0,0.1-19.9-27.3-31.2C83.8,6.9,71.9,6.1,60.9,9.8 c-7.2,2.5-14.6,7-18.8,15.2c0,0-13.6,2.6-13.8,18.4v20.9c0,0-7.1,8.6-1,17.8c0,0,2.4,4.4,7.9,5.9c0,0,12.1,24.2,39.8,24.2 c27.7,0,39.6-24,39.6-24S127,84.6,124.8,70.4z M108.9,79c0,0-6.6,22.7-33.9,23.8c0,0-22.3,1.6-33.7-23.7c0,0-6,1.9-7.1-5 c0,0-0.5-6.2,5.3-6.6c0,0,0.8-12.8,2.9-16.5c0,0,5.3,7.6,12,5.8c0,0,5.4-13.5,16.1-13.4c0,0,2.3,7.6-4.4,12.7 c0,0-0.8,1.8,2.3,1.8c3.1,0.1,19,1.4,27.8-7.9c0,0,3.4,1.7,2.4,9.5c0,0,0.7,3,3.5-0.6c0,0,5.5-5.2,6-6.9c0,0,2,4.9,2.6,15.3 c0,0,4.7,0.5,5.1,6.5C115.9,73.9,115.1,81.1,108.9,79z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 90.2,
    cy: 68,
    r: 4.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.7,
    cy: 68,
    r: 4.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 74.4,
    cy: 82.1,
    rx: 5.6,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4,142.5c6.8-16.3,23-26.6,40.1-25.8c15.3,0.8,29,11.4,35.4,25.8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarProfileLine);
export default __webpack_public_path__ + "static/media/SidebarProfileLine.01786205a158c485056721d9f2122b71.svg";
export { ForwardRef as ReactComponent };